import api from "../api";

export default class UserInfoApi {
  getUsersInfo() {
    return api.get("/users/profile");
  }
  uploadImage(formData: FormData) {
    return api.put("/users/profile/update/profile_image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  registerCard(formData: FormData) {
    return api.post("/users/register_card", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  updateProfileImage(formData: FormData) {
    return api.put("/users/profile/update/profile_image/v2", formData);
  }
}
